<!-- home.component.html -->

<div class="home-background">
  <img
    src="assets/EllipseBG.webp"
    alt="Décor Ellipse"
    class="decor-ellipse"
    width="859"
    height="1952"
    decoding="async"
    loading="lazy"
  />
  <img
    src="assets/WaveMiddle.webp"
    alt="Décor Vague Milieu"
    class="decor-wave"
    width="3107"
    height="5486"
    decoding="async"
    loading="lazy"
  />
  <img
    src="assets/CircleTopRight.webp"
    alt="Décor Cercle Haut Droite"
    class="decor-topright"
    width="2000"
    height="2000"
    decoding="async"
    loading="lazy"
  />
</div>

<div class="home-content">
  <div class="home-title-group">
    <h1 class="home-title">La solution simple et intuitive pour des rondes sécurisées</h1>
    <p class="home-subtitle">
      Traçabilité fiable, simplicité d’utilisation et sécurité renforcée pour vous offrir sérénité
      et valoriser le travail de vos équipes
    </p>
    <div class="video-container">
      <video
        class="home-video"
        width="1280"
        height="720"
        controls
        preload="none"
        poster="assets/presentation-poster.jpg"
        decoding="async"
        loading="lazy"
      >
        <source src="assets/presentation-720p-quality.webm" type="video/webm" />
        <source src="assets/presentation-720p-quality.mp4" type="video/mp4" />
        Votre navigateur ne supporte pas la balise vidéo.
      </video>
    </div>
  </div>
  <div class="feature-section">
    <div class="feature-card">
      <img
        src="assets/horloge.webp"
        alt="Scan"
        width="58"
        height="59"
        style="height: auto"
        loading="lazy"
        decoding="async"
      />

      <h3>Traçabilité Garantie</h3>
      <p>Chaque scan est horodaté</p>
    </div>
    <div class="feature-card">
      <img
        src="assets/bouclier.webp"
        alt="Preuves"
        width="58"
        height="59"
        style="height: auto"
        loading="lazy"
        decoding="async"
      />
      <h3>Preuves Solides</h3>
      <p>Historique complet</p>
    </div>
    <div class="feature-card">
      <img
        src="assets/liste.webp"
        alt="Flexibilité"
        width="58"
        height="59"
        style="height: auto"
        loading="lazy"
        decoding="async"
      />
      <h3>Flexibilité Complète</h3>
      <p>Tâches et horaires personnalisés</p>
    </div>
    <div class="fonctionnalites-section">
      <h2 class="fonctionnalites-title">Fonctionnalités</h2>
      <p class="fonctionnalites-subtitle">Des outils pensés pour vos équipes terrain</p>

      <div class="fonctionnalites-items">
        <div class="fonctionnalite-item">
          <img
            src="assets/android.webp"
            alt="android"
            width="60"
            height="60"
            style="width: 17%; height: auto"
            loading="lazy"
            decoding="async"
          />
          <p>Application Qaryos</p>
        </div>

        <div class="fonctionnalite-item">
          <img
            src="assets/scan.webp"
            alt="Scan QR Code"
            width="60"
            height="60"
            loading="lazy"
            decoding="async"
          />
          <p>Scan des QR Codes</p>
        </div>

        <div class="fonctionnalite-item">
          <img
            src="assets/rapport.webp"
            alt="Rapport"
            width="512"
            height="512"
            loading="lazy"
            decoding="async"
          />
          <p>Rapport automatique</p>
        </div>
        <div class="fonctionnalite-item">
          <img
            src="assets/tableau.webp"
            alt="Tableau de bord"
            width="46"
            height="47"
            loading="lazy"
            decoding="async"
          />
          <p>Tableau de bord</p>
        </div>
      </div>
    </div>
    <div class="clients-section">
      <h2 class="clients-title">Ils ont choisi Qaryos</h2>
      <div class="clients-slider-wrapper">
        <div class="clients-carousel">
          <div class="clients-track">
            <img
              src="assets/novotel.webp"
              alt="Logo Novotel LGM"
              width="180"
              height="78"
              loading="lazy"
            />
            <img
              src="assets/eklo.webp"
              alt="Logo Eklo Montpellier"
              width="300"
              height="128"
              style="width: 15%; height: auto"
              loading="lazy"
            />
            <img
              src="assets/novotel.webp"
              alt="Logo Novotel LGM"
              width="180"
              height="78"
              loading="lazy"
            />
            <img
              src="assets/eklo.webp"
              alt="Logo Eklo Montpellier"
              width="300"
              height="128"
              style="width: 15%; height: auto"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
